import React, { Suspense, lazy } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { withAuthenticatedRoute } from 'lib/auth'
import {
  buildCoachFastBookOverlayPath,
  COACH_SCHEDULE_PATH,
  isCoachBookStudentComposePhase,
  parseCoachBookStudentSearch,
} from 'lib/pga-coach/coach-book-student'
const CoachBookStudentStepController = lazy(() =>
  import('./coach-book-student-step-controller'),
)

const CoachBookStudentPage = () => {
  const location = useLocation()
  const params = parseCoachBookStudentSearch(location.search)

  if (isCoachBookStudentComposePhase(params)) {
    return (
      <Redirect
        to={buildCoachFastBookOverlayPath(COACH_SCHEDULE_PATH, params)}
      />
    )
  }

  return (
    <Suspense fallback={null}>
      <CoachBookStudentStepController />
    </Suspense>
  )
}

export default withAuthenticatedRoute(CoachBookStudentPage)
